import { Component, Input, OnInit } from "@angular/core";
import { EstadoPeriodontograma } from "app/models/periodontograma.interface";
import { EstadoOdontograma } from "app/models/odontograma.interface";
import { PeriodontogramaConfigService } from "app/services/periodontograma-config.service";

@Component({
  selector: "app-periodontograma-detalle",
  templateUrl: "./periodontograma-detalle.component.html",
  styleUrls: ["./periodontograma-detalle.component.scss"],
})
export class PeriodontogramaDetalleComponent implements OnInit {
  @Input() estado: EstadoPeriodontograma = {};
  @Input() odontogramaEstado: EstadoOdontograma = {};
  @Input() denticion: "adulto" | "nino" | "mixta" = "adulto";

  constructor(public configService: PeriodontogramaConfigService) {}

  ngOnInit(): void {
    this.configService.cargar().subscribe();
  }
}
